import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Alert } from '$HVUI';
const DeactivatedBanner = ({ companyTitle }) => {
    return (_jsxs(_Fragment, { children: [_jsx("h2", { style: {
                    fontWeight: 400,
                    marginBottom: '2rem'
                }, children: companyTitle }), _jsx("div", { style: {
                    width: '80%',
                    maxWidth: '800px',
                    margin: '0 auto'
                }, children: _jsx(Alert, { type: "error", message: _jsxs("p", { style: {
                            fontSize: 'var(--16px)',
                            marginBottom: 0,
                            textAlign: 'left'
                        }, children: ["Registration is no longer available. Please contact your clinic if you have any questions. If you have a Healthvana account and want to view your existing health records, log into your account", ' ', _jsx("a", { href: "/signin/", children: "here" }), "."] }) }) })] }));
};
export default DeactivatedBanner;
